<template>
  <div>
    <WrapperPreviewCategory customClass="section-preview_lk">
      <GridTable
        :data-rows="serverData"
        :rewrite-headers="rwrw"
        :headers="headers.massive"
        :headers-for-rows="headersForRows"
        :loading-data="loadingData"
        :num-cols="headers.countCells"
        :max-table-height="maxTableHeight"
        ref="npg-table"
        key="form-A"
      >
        <template #header-npg0="{item}">
          {{ item.text }}
        </template>
        <template v-for="item in headersForRows" v-slot:[calcHeaderName(item.dataField)]>
          <div :key="item.dataField" :class="item.headerClass" style="max-height: 22px;min-width: 100%">
            <template v-if="item.text === '1'">
              <div style="min-width: 60px">1</div>
              <div class="text-center" style="width: 100%">2</div>
            </template>
            <template v-else>
              <div class="d-flex flex-row align-center" style="max-height: 22px;">
                {{ item.text }}
                <v-btn small icon @click="openTooltip(item.dataField)">
                  <v-icon
                    :size="15"
                    class="grey-light-color__important "
                  >
                    mdi-information
                  </v-icon>
                </v-btn>
              </div>
            </template>
          </div>
        </template>
        <template #npg="{row}">
          <template v-if="row.uslName">
            <div class="font-weight-bold font-size-medium ">
              {{ row.uslName[0].toUpperCase() + row.uslName.slice(1) }}
            </div>
          </template>
          <template v-else>
            <div style="">
              {{ row.kcpGroup.code }}
            </div>
            <div class="ml-3">
              {{ row.kcpGroup.name }}
            </div>
          </template>
        </template>
      </GridTable>
    </WrapperPreviewCategory>
    <tooltip-forms5-dialog
      ref="tooltip-dialog"
      :data-field="dataFieldTooltip"
    >
    </tooltip-forms5-dialog>
  </div>
</template>

<script>
import GridTable from "@/components/GridTable/GridTable";
import formA from "./configs/formA";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import tooltipForms5Dialog from "@/components/Dialogs/tooltipForms5Dialog";
import {setAppealDialog} from "@/mixins/forms5/appealDialog";
import {fiveFormsMixin} from "@/mixins/formUsl";
import Form5Controller from "@/controllers/Organizations/Form5Controller";
import {mapGetters} from "vuex";

export default {
  name: "formA",
  mixins: [headerTooltipFunctions, setAppealDialog, fiveFormsMixin],
  // eslint-disable-next-line vue/no-unused-components
  components: {WrapperPreviewCategory, GridTable, tooltipForms5Dialog},
  props: {
    chosenChildOrg: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
  },
  
  data() {
    return {
      serverData: [],
      loadingData: false,
      changingHeaders: false,
      headers: formA,
      loadingMenu: {value: false, id: ''},
      full: false,
      rwrw: false
    }
  },
  
  computed: {
    ...mapGetters('spr', {getChosenOrgId: 'getChosenOrgId'}),
    maxTableHeight() {
      return window.innerHeight - 225 + 'px'
    },
    headersForRows() {
      return this.headers.massive.filter(el => el.variable).map(el => {
        return {
          ...el,
          styles: (row) => {
            if (el.dataField !== 'npg')
              return row.uslName ? 'display: none;' : 'justify-content: unset; text-align: center; '
            else
              return ''
          },
          colsDataCalc: (row) => {
            if (el.dataField !== 'npg')
              return 1;
            else
              return row.uslName ? 7 : 1;
          },
          props: (row, cell, loading) => {
            return {
              value: row[cell.dataField],
              title: '',
              cell: cell,
              id: row.id,
              row: row,
              loading: loading,
            }
          }
        }
      })
    },
  },
  
  watch: {
    getChosenOrgId() {
      this.loadingDataTable();
    }
  },
  
  created() {
    this.loadingDataTable();
  },
  
  methods: {
    loadFullInfo() {
      this.full = !this.full;
      this.loadingDataTable()
    },
    async loadingDataTable() {
      this.loadingData = true;
      try {
        this.serverData = await Form5Controller.getForm2('formA', true, this.chosenChildOrg?.id)
        this.loadingData = false;
      } catch (e) {
        this.loadingData = false;
      }
    },
  },
}
</script>

<style scoped>

</style>